// The button that loads a newer screen (app-update.ts), on every screen.
//
// Where: floating at the bottom left, over the sidebar's column (bottom center
// and right cover the composer); on a phone, in the middle of the header row
// (the bottom is the Dock and the home bar); inside an app that draws its own
// bar at the top (`data-phone-host`), under that bar, where it can be pressed.
// Floating, so the body does not move. One button that says what it does; no
// blinking: it can wait until the person has a moment.

import { m } from "@trameria/cloud-i18n";
import type { ScreenPart } from "@trameria/ui-core";
import { type AppUpdate, useAppUpdateAvailable } from "./app-update";

export function appUpdatePart(update: AppUpdate): ScreenPart {
  return {
    id: "app-update",
    Background: function AppUpdateBar() {
      const available = useAppUpdateAvailable(update);
      if (!available) return null;
      return (
        <div
          role="status"
          data-app-update=""
          className="fixed bottom-3 left-[64px] z-40 max-sm:bottom-auto max-sm:left-1/2 max-sm:top-[calc(env(safe-area-inset-top,0px)+14px)] max-sm:w-max max-sm:-translate-x-1/2"
        >
          <button
            type="button"
            onClick={update.reload}
            className="box-border inline-flex h-8 cursor-pointer items-center whitespace-nowrap rounded-2xl border border-border bg-surface px-[13px] pb-px text-[13px] text-body shadow-[var(--shadow-popover)] hover:border-field-strong"
          >
            {m.web_app_update_load()}
          </button>
        </div>
      );
    },
  };
}
